module.exports = __webpack_public_path__ + "img/ring_0_0_1_null@2x.bd369dbe.png";